"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackgroundFromHoverState = exports.TIMELINE_TRACK_SEPARATOR = exports.LINE_COLOR = exports.SELECTED_GUIDE = exports.UNSELECTED_GUIDE = exports.LIGHT_TRANSPARENT = exports.BLUE_DISABLED = exports.BLUE = exports.WARNING_COLOR = exports.TEXT_COLOR = exports.FAIL_COLOR = exports.TIMELINE_BACKGROUND = exports.INPUT_BORDER_COLOR_HOVERED = exports.INPUT_BORDER_COLOR_UNHOVERED = exports.CLEAR_HOVER = exports.VERY_LIGHT_TEXT = exports.RULER_COLOR = exports.LIGHT_TEXT = exports.SELECTED_BACKGROUND = exports.LIGHT_COLOR = exports.BORDER_COLOR = exports.INPUT_BACKGROUND = exports.BACKGROUND__TRANSPARENT = exports.BACKGROUND = void 0;
exports.BACKGROUND = 'rgb(31,36,40)';
exports.BACKGROUND__TRANSPARENT = 'rgba(31,36,40, 0)';
exports.INPUT_BACKGROUND = '#2f363d';
exports.BORDER_COLOR = '#000';
exports.LIGHT_COLOR = '#ddd';
exports.SELECTED_BACKGROUND = 'hsla(0, 0%, 100%, 0.15)';
exports.LIGHT_TEXT = '#A6A7A9';
exports.RULER_COLOR = '#808080';
exports.VERY_LIGHT_TEXT = 'rgba(255, 255, 255, 0.3)';
const SELECTED_HOVER_BACKGROUND = 'hsla(0, 0%, 100%, 0.25)';
exports.CLEAR_HOVER = 'rgba(255, 255, 255, 0.06)';
exports.INPUT_BORDER_COLOR_UNHOVERED = 'rgba(0, 0, 0, 0.6)';
exports.INPUT_BORDER_COLOR_HOVERED = 'rgba(255, 255, 255, 0.05)';
exports.TIMELINE_BACKGROUND = '#111';
exports.FAIL_COLOR = '#ff3232';
exports.TEXT_COLOR = '#fff';
exports.WARNING_COLOR = '#f1c40f';
exports.BLUE = '#0b84f3';
exports.BLUE_DISABLED = '#284f73';
exports.LIGHT_TRANSPARENT = 'rgba(255, 255, 255, 0.7)';
exports.UNSELECTED_GUIDE = '#7e1219';
exports.SELECTED_GUIDE = '#d22d3a';
exports.LINE_COLOR = '#363A3E';
exports.TIMELINE_TRACK_SEPARATOR = 'rgba(0, 0, 0, 0.3)';
const getBackgroundFromHoverState = ({ selected, hovered, }) => {
    if (selected) {
        if (hovered) {
            return SELECTED_HOVER_BACKGROUND;
        }
        return exports.SELECTED_BACKGROUND;
    }
    if (hovered) {
        return exports.CLEAR_HOVER;
    }
    return 'transparent';
};
exports.getBackgroundFromHoverState = getBackgroundFromHoverState;
